'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.typeaheadComponent = undefined;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var typeaheadComponent = exports.typeaheadComponent = {
    template: require('./typeahead.html'),
    bindings: {
        searchString: '=',
        hasFocus: '=',
        searchSource: '&',
        onChange: '&',
        displayContext: '<',
        inputId: '<',
        isDisabled: '<',
        inputStyle: '<'
    },
    controllerAs: 'vm',
    controller: ["$timeout", function controller($timeout) {
        'ngInject';

        var vm = this;

        _angular2.default.element(vm.inputId + '.input-sm').siblings('input.tt-hint').addClass('hint-small');
        _angular2.default.element(vm.inputId + '.input-lg').siblings('input.tt-hint').addClass('hint-large');

        // TYPE AHEAD
        $timeout(function () {
            //DOM has finished rendering
            _angular2.default.element('#' + vm.inputId).typeahead({
                items: 'all',
                source: function source(query, process) {
                    vm.searchSource({ query: query }).then(function (results) {
                        return process(results);
                    });
                },
                updater: function updater(item) {
                    vm.onChange({ item: item });
                    return item;
                },
                displayText: function displayText(item) {
                    //make dynamic with input binding and scope.eval
                    switch (vm.displayContext) {
                        case 'CITY':
                            return item.postalCode + ' - ' + item.name;
                        case 'STREET':
                            return '' + item.name;
                        default:
                            return item.nationalNumber + ' - ' + item.name;
                    }
                }
            });
        });
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/common/typeahead.js
// module id = 925
// module chunks = 0